import { ReactNode, useEffect } from "react";
import ReactDOM from "react-dom";

export type DropdownDialogProps = {
    isOpen: boolean;
    onClose?: () => void;
    children: ReactNode | ReactNode[];
};

export const DROPDOWN_DIALOG_DIALOG_ID = 'dropdown-dialog';

const DropdownDialog = (props: DropdownDialogProps) => {
    return ReactDOM.createPortal(
        props.children,
        document.getElementById(DROPDOWN_DIALOG_DIALOG_ID)!
    );
}

export default DropdownDialog;
